import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import LandingPage from './components/pages/LandingPage';
import ContestPage from './components/pages/ContestPage';
import ContestRules from './components/pages/ContestRules';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import ForgotPassword from './components/auth/ForgotPassword';
import PageTracker from './components/analytics/PageTracker';
import Admin from './components/pages/Admin';
import './styles/fonts.css';
import './styles/global.css';

const loadGoogleMapsScript = () => {
  if (window.google) {
    return Promise.resolve();
  }

  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_VV_CONTEST_GOOGLE_PLACES_KEY}&libraries=places`;
  script.async = true;
  script.defer = true;

  return new Promise((resolve, reject) => {
    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);
    document.head.appendChild(script);
  });
};

function App() {
  useEffect(() => {
    loadGoogleMapsScript()
      .catch(error => console.error('Error loading Google Maps:', error));
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <div className="App">
            <PageTracker />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/dashboard" element={<ContestPage />} />
              <Route path="/contest-rules" element={<ContestRules />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/login" element={<LandingPage />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
